import type { NexusHandler } from "@otto-ec/global-resources/nexus";
import { AppType, type AppsGlobal } from "./index.js";

export const runningInApp: NexusHandler<AppsGlobal["runningInApp"]> = () => {
    return !!window.o_apps_android || !!window.webkit?.messageHandlers;
}

export const appType: NexusHandler<AppsGlobal["appType"]> = () => {
    if (window.o_apps_android) {
        return AppType.ANDROID;
    } else if (window.webkit?.messageHandlers) {
        return AppType.IOS;
    } else {
        return undefined;
    }
}

export const appVersion: NexusHandler<AppsGlobal["appVersion"]> = async () => {
    const appTypeResult = appType();
    if (appTypeResult === AppType.ANDROID) {
        return window.o_apps_android?.getAppVersion?.();
    } else if (appTypeResult === AppType.IOS) {
        return window.webkit?.messageHandlers?.getAppVersion?.postMessage({});
    } else {
        return undefined;
    }
}
